// Sidebar imports
import {
  UilEstate,
  UilClipboardAlt,
  UilUsersAlt,
  UilPackage,
  UilChart,
} from "@iconscout/react-unicons";


// Sidebar Data
export const SidebarData = [
  {
    icon: UilEstate,
    heading: "Dashboard",
  },
  {
    icon: UilClipboardAlt,
    heading: "Cursos",
  },
  {
    icon: UilUsersAlt,
    heading: "Usuarios",
  },
  {
    icon: UilPackage,
    heading: 'Evaluaciones'
  },
  {
    icon: UilChart,
    heading: 'Estadísticas'
  },
];

